import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jmcLogo from "../../assets/jmc-logo.png";

type Props = {
  title: string;
  active: "dashboard" | "profile" | "register" | "forms" | "uploads" | "submitReview";
  children: React.ReactNode;
};

export default function MerchantLayout({ title, active, children }: Props) {
  const navigate = useNavigate();

  const [merchantType, setMerchantType] = useState<string>("");
  const [sidebarWarning, setSidebarWarning] = useState<string>("");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const logout = () => {
    localStorage.removeItem("merchant_access_token");
    localStorage.removeItem("merchant_id");
    localStorage.removeItem("merchant_company_name");
    navigate("/merchant-login");
  };

  // ✅ Load merchant_type from backend to avoid stale local UI
  const fetchMerchantType = async () => {
    const token = localStorage.getItem("merchant_access_token");
    if (!token) return;

    try {
      const res = await fetch("/api/merchant/me", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.status === 401) {
        logout();
        return;
      }

      if (!res.ok) return;

      const json = await res.json();
      const mt = (json?.merchant?.merchant_type || "").trim();
      setMerchantType(mt);
    } catch {
      // ignore - don’t block layout rendering
    }
  };

  useEffect(() => {
    fetchMerchantType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const typeSelected = merchantType === "個人" || merchantType === "法人";

  const newApplicationDisabled = typeSelected;
const continueApplicationDisabled = !typeSelected;

  const NavButton = ({
    label,
    onClick,
    isActive,
  }: {
    label: string;
    onClick: () => void;
    isActive?: boolean;
  }) => (
    <button
      onClick={() => {
        setSidebarWarning("");
        onClick();
      }}
      style={{
        width: "100%",
        textAlign: "left",
        padding: "14px 16px",
        borderRadius: 14,
        border: "1px solid rgba(255,255,255,0.18)",
        background: isActive ? "rgba(255,255,255,0.18)" : "rgba(255,255,255,0.08)",
        color: "#fff",
        fontWeight: 800,
        cursor: "pointer",
      }}
    >
      {label}
    </button>
  );

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "linear-gradient(180deg, #2f66a8 0%, #103a68 55%, #062347 100%)",
      }}
    >
      {/* Sidebar */}
      <aside
        style={{
          width: sidebarCollapsed ? 76 : 260,
padding: sidebarCollapsed ? 12 : 18,
transition: "width 0.2s ease, padding 0.2s ease",
          background: "linear-gradient(180deg, #2e5f9e 0%, #0b1f3b 100%)",
          borderRight: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        {/* Brand */}
        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 18 }}>
          <img src={jmcLogo} alt="JMC" style={{ width: 46, height: 46 }} />
          {!sidebarCollapsed && (
  <div>
    <div style={{ color: "#fff", fontSize: 20, fontWeight: 900 }}>JMC</div>
    <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 12 }}>
      加盟店登録ポータル
    </div>
  </div>
)}
        </div>



        <button
  type="button"
  onClick={() => setSidebarCollapsed((prev) => !prev)}
  style={{
    width: "100%",
    marginBottom: 14,
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.18)",
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    fontWeight: 900,
    cursor: "pointer",
  }}
>
  {sidebarCollapsed ? "☰" : "← 縮小"}
</button>

        {/* ✅ Sidebar warning box (only when needed) */}
        {sidebarWarning && (
          <div
            style={{
              marginBottom: 12,
              background: "rgba(255, 237, 213, 0.95)",
              border: "1px solid rgba(251, 146, 60, 0.8)",
              color: "#7c2d12",
              padding: "10px 12px",
              borderRadius: 12,
              fontWeight: 900,
              fontSize: 12,
              lineHeight: 1.4,
            }}
          >
            {sidebarWarning}
          </div>
        )}

        {!sidebarCollapsed && (
  <div style={{ color: "rgba(255,255,255,0.65)", fontSize: 12, marginBottom: 10 }}>
    メインメニュー
  </div>
)}

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <NavButton
            label={sidebarCollapsed ? "🏠" : "🏠 ダッシュボード"}
            onClick={() => navigate("/merchant/dashboard")}
            isActive={active === "dashboard"}
          />

         
          
        </div>

        <div style={{ marginTop: 18 }}>
          <button
            onClick={logout}
            style={{
              width: "100%",
              padding: "14px 16px",
              borderRadius: 14,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "rgba(255,255,255,0.08)",
              color: "#fff",
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            {sidebarCollapsed ? "🚪" : "🚪 ログアウト"}
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1 }}>
        {/* Top bar */}
        <div
          style={{
            height: 78,
            background: "linear-gradient(90deg, #2e5f9e 0%, #0b1f3b 100%)",
            display: "flex",
            alignItems: "center",
            padding: "0 22px",
            color: "#fff",
            fontSize: 28,
            fontWeight: 900,
          }}
        >
          {title}
        </div>

        {/* Content container */}
        <div style={{ padding: 22 }}>
          <div
            style={{
              background: "#fff",
              borderRadius: 18,
              padding: 18,
              boxShadow: "0 10px 28px rgba(0,0,0,0.18)",
              maxWidth: 1100,
            }}
          >
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
